import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { isNil } from 'lodash-es';
import React from 'react';
export function isRenderableNode(node) {
    return !(isNil(node) || node === false);
}
export function newLineToBr(content) {
    if (typeof content !== 'string')
        return content;
    const lines = content.split('\n');
    return (_jsx(_Fragment, { children: lines.map((line, i) => (_jsxs(React.Fragment, { children: [i !== 0 && _jsx("br", {}), line] }, i))) }));
}
